import { Injectable } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CRUD_METHOD } from '../commons/util/emun';
import { Observable, tap } from 'rxjs';
import { IResponse } from '../commons/services/api/api-models-base.interface';
import { IRequestUser, IResponseUser, IResponseUserInfo } from '../commons/services/api/user/user-api.model.interface';
import { UserApiService } from '../commons/services/api/user/user-api.service';
import { customBlankSpacesValidator } from '../validations/form-validations';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  formGroup!: FormGroup;

  constructor(private _formBuilder: FormBuilder,
    private _userApiService: UserApiService) {
    this._loadFormGroup();
  }

  private _loadFormGroup(): void {
    this.formGroup = this._formBuilder.group(
      {
        id: [null],
        profile: [null, Validators.required],
        name: [null, [customBlankSpacesValidator, Validators.required]],
        lastName1: [null, [customBlankSpacesValidator, Validators.required]],
        lastName2: [null],
        userName: [null, [customBlankSpacesValidator, Validators.required]],
        password: [null, [customBlankSpacesValidator, Validators.required]],
        changePassword: [false],
        state: [true]
      }
    );
  }

  private _getMethod(method: CRUD_METHOD, request: IRequestUser, userId?: number): Observable<IResponse<string>> {
    return method === CRUD_METHOD.SAVE
      ? this._userApiService.add(request)
      : this._userApiService.update(userId, request);
  }

  getPassword(userId: number): Observable<IResponse<string>> {
    return this._userApiService.getPassword(userId);
  }

  listUsers(filter?: string, page?: number, rows?: number): Observable<IResponse<IResponseUserInfo[]>> {
    return this._userApiService.list(filter, page, rows);
  }

  loadUser(userId: number): Observable<IResponse<IResponseUser>> {
    return this._userApiService.getUserById(userId).pipe(
      tap((response) => {
        console.log("deot", response.result);
        if (response.success) {
          const userResponse = response.result;
          this.profileField.setValue(userResponse.perfilId);
          this.nameField.setValue(userResponse.nombres);
          this.lastName1Field.setValue(userResponse.apellidoPaterno);
          this.lastName2Field.setValue(userResponse.apellidoMaterno);
          this.userNameField.setValue(userResponse.nombreDeUsuario);
          this.passwordField.setValue(userResponse.clave),
            this.changePasswordField.setValue(userResponse.cambioDeClave ? true : false)
          this.stateField.setValue(userResponse.estado === 'ACTIVO' ? true : false)
        }
      })
    );
  }

  saveUser(method: CRUD_METHOD, confirmed: Array<any>, userId?: number): Observable<IResponse<string>> {
    const request: IRequestUser = {
      perfilId: this.profileField.value,
      nombres: this.nameField.value ? this.nameField.value.toUpperCase() : null,
      apellidoPaterno: this.lastName1Field.value ? this.lastName1Field.value.toUpperCase() : null,
      apellidoMaterno: this.lastName2Field.value ? this.lastName2Field.value.toUpperCase() : null,
      nombreDeUsuario: this.userNameField.value,
      clave: this.passwordField.value,
      cambioDeClave: this.changePasswordField.value ?? false,
      estado: this.stateField.value ? "ACTIVO" : "INACTIVO"
    };
    return this._getMethod(method, request, userId);
  }

  updatePassword(userId: number, newPassword: string) {
    return this._userApiService.updatePassword(userId, newPassword);
  }

  //gets
  get idField(): AbstractControl {
    return this.formGroup.get('id')!;
  }

  get profileField(): AbstractControl {
    return this.formGroup.get('profile')!;
  }

  get nameField(): AbstractControl {
    return this.formGroup.get('name')!;
  }

  get lastName1Field(): AbstractControl {
    return this.formGroup.get('lastName1')!;
  }

  get lastName2Field(): AbstractControl {
    return this.formGroup.get('lastName2')!;
  }

  get userNameField(): AbstractControl {
    return this.formGroup.get('userName')!;
  }

  get passwordField(): AbstractControl {
    return this.formGroup.get('password')!;
  }

  get changePasswordField(): AbstractControl {
    return this.formGroup.get('changePassword')!;
  }

  get stateField(): AbstractControl {
    return this.formGroup.get('state')!;
  }

}
